module.exports = __webpack_public_path__ + "static/lauren-jenkins-f856568249fb895cfb944f19b439c2c3.png";